import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EditTabsModel } from '../../utilities/edit-tabs/edit-tabs.model';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { AppTextService } from '@fi-shared/app-text';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-page-header',
    templateUrl: './fi-page-header.component.html',
    styleUrls: ['./fi-page-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-page-header' },
    standalone: false,
})
export class FiPageHeaderComponent {
    @Input() editTabsSettings: EditTabsModel;
    @Input() moreMenuItems: MoreMenuMobileSettingsModel;
    @Input() isSaveButtonShown: boolean = true;
    @Input() isMobileMenuShown: boolean = true;
    @Input() isBackButtonShown: boolean = true;
    @Input() headerIconClassName: string;
    @Output() onSave: EventEmitter<void> = new EventEmitter<void>();
    @Output() headerButtonClick: EventEmitter<void> = new EventEmitter<void>();

    constructor(private appTextService: AppTextService) {}

    save(): void {
        this.onSave.emit();
    }

    onHeaderButtonClick() {
        this.headerButtonClick.emit();
    }

    isMoreMenuDefined(): boolean {
        return isDefined(this.moreMenuItems);
    }

    getBackButtonText(): string {
        return this.editTabsSettings.ButtonBackTitle || this.appTextService.get('common.cancel');
    }

    getSaveButtonText(): string {
        return this.editTabsSettings.ButtonSaveTitle || this.appTextService.get('common.save');
    }
}
